<template>
  <v-container class="my-0">
    <!-- A title with instructions -->
    <v-container fluid>
      <!-- Title -->
      <v-layout class="display-2 blue-grey--text" justify-center>
        <v-flex shrink>{{ title }}</v-flex>
      </v-layout>
      <!-- Instructions -->
      <v-layout class="title font-weight-light blue-grey--text" justify-center>
        <v-flex shrink>{{ subtitle }}</v-flex>
      </v-layout>
    </v-container>
    <!-- The slot for more content -->
    <slot />
  </v-container>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String
    }
  }
};
</script>